module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PA-42e4ddc4a13677dff9a5133d31745de9.png";